import { useState, useEffect } from "react";

export default function useDebounce(callback, delay) {

  const [debouncedValue, setDebouncedValue] = useState(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(callback());
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [callback, delay]);

  return debouncedValue;
}
export function useDebounceForDataDeletion(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  console.log("From debounced: ", delay, value)
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}


